<template>
    <div class="bc">
        <div :style="setBackground">
            <div class="map">
                <div style="display: flex;align-items: center;height: 100%;">
                    <img
                        src="../image/map.png"
                        style="width: 20px;height: 20px; padding: 10px;background: #1989F9;border-radius: 50%;margin: 0 10px;"
                    />
                    <div>
                        <div>{{address}}</div>
                    </div>
                </div>
                <div>
                    <icon name="replay" color="#999999" size="30px" @click="getLocation()" v-if="refresh"/>
                    <loading size="30"  v-else/>
                </div>
            </div>
        </div>
        <div style="background-color: #fff;margin: 10px 0;padding-bottom: 10px;">
            <div style="padding: 10px;border-bottom: 1px solid #eee;font-weight: bold;font-size: 16px;">举报证据</div>
            <UploadImage
                    :imageList="submitImageList"
                    :sourceType="['camera']"
                    style="margin:5px;"
                    :count="4"
                    @imageChange="imageChange"
                    :edit="true"
            />
        </div>
        <div style="background-color: #fff;margin: 10px 0;padding-bottom: 10px;">
            <div style="padding: 10px;border-bottom: 1px solid #eee;font-weight: bold;font-size: 16px;">问题描述</div>
            <Field
                v-model="describe"
                rows="3"
                autosize
                type="textarea"
                placeholder="请输入问题描述"
            />
        </div>
        <div class="fixed-bottom-button">
            <Button type="info" block  @click="submit">确认提交</Button>
        </div>
    </div>
</template>

<script>
     import {Icon,Grid, GridItem,Loading,Field,Button} from "vant";
     import UploadImage from "@/components/UploadImage";
     import {mapGetters} from 'vuex'

     export default {
        components: {
            Icon,Grid, GridItem,Loading,UploadImage,Field,Button
        },
        computed: {
            ...mapGetters({position: 'wechat/position'})
        },
        data () {
            return {
                setBackground: {
                    backgroundImage: "url(" + require("../image/bk2.png") + ")",
                    backgroundRepeat: "no-repeat",
                    backgroundSize:'100%',
                    height: '60px',
                    padding: '10px'
                },
                address:'',
                describe:'',
                lat:'',
                lng:'',
                submitImageList:[],
                type:this.$route.params.code,
                unitId:'',
                refresh:true
            }
        },
        comments:{
            
        },
        mounted() {
            window.document.title = this.$route.params.codeName
            const {unitOrOrgan} = this.$default
            this.unitId = unitOrOrgan.id,
            this.address = this.position.address,
            this.lat = this.position.latitude,
            this.lng = this.position.longitude
        },
        methods:{
            getLocation() {
                this.$store.dispatch({type: 'wechat/getLocation'})
                this.refresh = false
            },
            imageChange(imageList) {
                this.submitImageList = imageList;
            },
            submit() {
                let params = {
                    address:this.address,
                    describe:this.describe,
                    lat:this.lat,
                    lng:this.lng,
                    submitImageList:this.submitImageList,
                    type:this.type,
                    unitId:this.unitId,
                }
                console.info('params',params)
                this.$http.tokiot.snapshot.create(params)
                    .then(ret => {
                        if (ret) {

                            this.$toast.success('提交成功')
                            setTimeout(() => this.$router.go(-2), 1000)
                        }
                    })

            }
        },
        watch:{
            position:{
               deep:true, //深度监听设置为 true
               handler(val) {
                    this.address = val.address,
                    this.lat =val.latitude,
                    this.lng = val.longitude,
                    setTimeout(() => {
                        this.refresh = true
                    }, 2000);
               }
            }
        }
     }
</script>

<style>
    .bc {
        width: 100%;
        height: 100%;
        position: fixed;
        background-color: #F3F3F3;
        
    }
    .map {
        background-color: #fff;
        height: 100%;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 15px;
    }
    .fixed-bottom-button {
        position: fixed;
        margin-left: 8px;
        bottom: 8px;
        width: calc(100% - 16px);
    }
</style>